import { Item } from "src/app/inspection/model/item";
import { Command } from "src/app/shared/ddd/models/command";

export class AddItemsToInspectionCommand implements Command {
  items: Item[];

  inspectionId: string;

  constructor(items: Item[], inspectionId: string) {
    this.items = items;
    this.inspectionId = inspectionId;
  }
}
